module.exports = "../images/icons/printer.svg";